

namespace PaperTrail.NewsletterControl{

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.maximizable()
    export class NewsEditorDialog extends Serenity.Extensions.GridEditorDialog<NewsRow> {
        protected getFormKey() { return NewsForm.formKey; }
        protected getNameProperty() { return NewsRow.nameProperty; }
        protected getLocalTextPrefix() { return NewsRow.localTextPrefix; }

        protected form: NewsForm;
        private loadedState: string;
        //public  _claimantID: number;

        constructor() {
            super();
            this.form = new NewsForm(this.idPrefix);
            Serenity.Extensions.DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);


            
        }


        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            this.loadedState = this.getSaveState();
        }

    }
}